import { render, staticRenderFns } from "./FeaturedPartnerships.vue?vue&type=template&id=e229e31c&scoped=true&"
import script from "./FeaturedPartnerships.vue?vue&type=script&lang=js&"
export * from "./FeaturedPartnerships.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPartnerships.vue?vue&type=style&index=0&id=e229e31c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e229e31c",
  null
  
)

export default component.exports